import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { voucherTypesActions, useSelector } from "inbooma-api";
import ItemMobile from "../viewItems/ItemMobile";
import ItemWeb from "../viewItems/ItemWeb";

const VoucherListItem = (props) => {
  const { dispatch, voucher, setInitialized, onRemoveVoucher, showNotification, index } = props;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const currentUrl = new URL(window.location.href);
  const [localVoucher, setLocalVoucher] = useState(voucher);
  const [voucherPending, setVoucherPending] = useState(null);
  const _patchVoucher = useSelector((state) => state["voucher_types_data"].patchVoucherType);

  useEffect(() => {
    if (_patchVoucher.success === "" || !voucherPending) {
      return;
    }

    if (_patchVoucher.success === true) {
      let clone = { ...localVoucher };
      clone.status = _patchVoucher.data.status;
      setLocalVoucher(clone);
      showNotification("success", localVoucher.name);
    } else {
      showNotification(
        "warning",
        null,
        typeof _patchVoucher.data.message !== "undefined"
          ? _patchVoucher.data.message
          : t("could_not_be_saved_${a}", { a: t("voucher") }, "capital") + " " + localVoucher.name,
      );
      console.log("Failed patching voucher!");
    }
    setVoucherPending(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_patchVoucher]);

  const onChangeStatus = (status, voucher) => {
    dispatch(
      voucherTypesActions.patchVoucherType({
        id: voucher,
        data: {
          status: status.currentTarget.checked,
        },
        token: Biscuit.get("token"),
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setVoucherPending(voucher);
  };

  return (
    <>
      <ItemWeb
        localVoucher={localVoucher}
        key={"item_" + localVoucher.id + "_web"}
        setInitialized={setInitialized}
        voucherPending={voucherPending}
        onChangeStatus={onChangeStatus}
        currentUrl={currentUrl}
        onRemoveVoucher={onRemoveVoucher}
        index={index}
      />
      <ItemMobile
        localVoucher={localVoucher}
        key={"item_" + localVoucher.id + "_mobile"}
        setInitialized={setInitialized}
        voucherPending={voucherPending}
        onChangeStatus={onChangeStatus}
        currentUrl={currentUrl}
        onRemoveVoucher={onRemoveVoucher}
        index={index}
      />
    </>
  );
};

export default VoucherListItem;
